// React is used implicitly in the JSX
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import DashboardLayout from './components/layout/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Revenue from './pages/Revenue';
import Customers from './pages/Customers';
import Subscriptions from './pages/Subscriptions';
import Plans from './pages/Plans';
import Tenants from './pages/Tenants';
import Users from './pages/Users';
import Invoices from './pages/Invoices';
import Payments from './pages/Payments';
import MyProfile from './pages/MyProfile';
import Settings from './pages/Settings';
import Debug from './pages/Debug';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import AuthRoute from './components/auth/AuthRoute';
import { AuthProvider } from './contexts/AuthContext';
import { checkSupabaseConnection } from './lib/debugUtils';
import CustomerDetail from './pages/CustomerDetail';
import InvoiceDetail from './pages/InvoiceDetail';
import PaymentDetail from './pages/PaymentDetail';
import UserDetail from './pages/UserDetail';
import TenantDetail from './pages/TenantDetail';

export function App() {
  useEffect(() => {
    // Run the Supabase connection check when app initializes
    checkSupabaseConnection().then(status => {
      console.log('Supabase connection status:', status);
    });
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/debug" element={<Debug />} />
          
          {/* Protected Routes */}
          <Route element={<AuthRoute />}>
            <Route path="/dashboard" element={
              <DashboardLayout>
                <Dashboard />
              </DashboardLayout>
            } />
            <Route path="/revenue" element={
              <DashboardLayout>
                <Revenue />
              </DashboardLayout>
            } />
            <Route path="/customers" element={
              <DashboardLayout>
                <Customers />
              </DashboardLayout>
            } />
            <Route path="/customers/:id" element={
              <DashboardLayout>
                <CustomerDetail />
              </DashboardLayout>
            } />
            <Route path="/tenants" element={
              <DashboardLayout>
                <Tenants />
              </DashboardLayout>
            } />
            <Route path="/tenants/:id" element={
              <DashboardLayout>
                <TenantDetail />
              </DashboardLayout>
            } />
            <Route path="/users" element={
              <DashboardLayout>
                <Users />
              </DashboardLayout>
            } />
            <Route path="/users/:id" element={
              <DashboardLayout>
                <UserDetail />
              </DashboardLayout>
            } />
            <Route path="/invoices" element={
              <DashboardLayout>
                <Invoices />
              </DashboardLayout>
            } />
            <Route path="/invoices/:id" element={
              <DashboardLayout>
                <InvoiceDetail />
              </DashboardLayout>
            } />
            <Route path="/payments" element={
              <DashboardLayout>
                <Payments />
              </DashboardLayout>
            } />
            <Route path="/payments/:id" element={
              <DashboardLayout>
                <PaymentDetail />
              </DashboardLayout>
            } />
            <Route path="/subscriptions" element={
              <DashboardLayout>
                <Subscriptions />
              </DashboardLayout>
            } />
            <Route path="/plans" element={
              <DashboardLayout>
                <Plans />
              </DashboardLayout>
            } />
            <Route path="/profile" element={
              <DashboardLayout>
                <MyProfile />
              </DashboardLayout>
            } />
            <Route path="/settings" element={
              <DashboardLayout>
                <Settings />
              </DashboardLayout>
            } />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}